import { phoneNumberInput } from '@/constants/form_inputs';
import { ReceivedByLabels } from '@/models';

const receivedByItems = Object.entries(ReceivedByLabels).map(
  ([value, label]) => ({
    value,
    label,
  }),
);
export const ReporterContactPhoneField = {
  ...phoneNumberInput,
  name: 'reporter.contactPhoneNumber',
  label: 'Contact phone number',
  styles: {
    xs: 4,
    sx: {
      mt: 2,
    },
  },
};

export const ReporterReceivedByField = {
  name: 'reporter.receivedBy',
  type: 'select',
  label: 'Received from',
  items: receivedByItems,
  styles: {
    xs: 12,
    sx: {
      mt: 2,
    },
  },
};
